import { Col, Row } from "react-bootstrap";
import "styles/page.css";
import { handleOpenPdf } from "utils";
import { LinkButton } from "components/buttons";
import { ASSETS_BASE_URL } from "constants";

function Compliance() {
  return (
    <>
      <style type="text/css">
        {`

        @media (min-width: 768px) {
          .compliance-card {
            border-radius: 5px;
            border: 1px solid #D6D6D6;
            background: var(--white, #FFF);
            margin-bottom: 12px;
            padding: 10px;
            min-height: 135px;
          }
        }

         @media (max-width: 767px) {
          .compliance-card {
            border-radius: 5px;
            border: 1px solid #D6D6D6;
            background: var(--white, #FFF);
            margin-bottom: 12px;
            padding: 10px;
            min-height: auto;
          }
        }

          .compliance-card p{
            padding: 0px;
            margin: 0px;

            color: var(--alrajhi-Brand-1000, #000045);
            font-family: "Ping AR + LT";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%; /* 24px */
            letter-spacing: -0.368px;

            text-align: center;
          }

          .compliance-card-section {
            // margin-left: -15px;
            // margin-right: 15px;
          }

          .spacer {
          height: 80px;}
          
       
        `}
      </style>

      <div className="container page">
        <h1 className="page-title">Compliance & AML Statement</h1>

        <p className="page-subtitle">
          Al Rajhi Banking & Investment Corporation (Malaysia) Berhad's
          commitment to compliance excellence underpins the approach the Bank
          takes to manage compliance risks in the Bank. Compliance at the Bank
          encompasses the following:
        </p>

        <div className="compliance-card-section">
          <Row>
            <Col md={3}>
              <div className="compliance-card d-flex align-items-center justify-content-center">
                <p>
                  Embracing <b>ethical conduct</b>
                </p>
              </div>
            </Col>

            <Col md={3}>
              <div className="compliance-card d-flex align-items-center justify-content-center">
                <p>
                  <b>Ensuring customers</b> are treated fairly
                </p>
              </div>
            </Col>

            <Col md={3}>
              <div className="compliance-card d-flex align-items-center justify-content-center">
                <p>
                  <b>Adopting good standards</b> of market conduct
                </p>
              </div>
            </Col>

            <Col md={3}>
              <div className="compliance-card d-flex align-items-center justify-content-center">
                <p>
                  Ensuring <b>adequate product transparency</b> & disclosure
                </p>
              </div>
            </Col>

            <Col md={3}>
              <div className="compliance-card d-flex align-items-center justify-content-center">
                <p>
                  Protecting <b>customers' data</b>
                </p>
              </div>
            </Col>

            <Col md={3}>
              <div className="compliance-card d-flex align-items-center justify-content-center">
                <p>
                  <b>Combating money laundering</b> and terrorist financing
                </p>
              </div>
            </Col>

            <Col md={3}>
              <div className="compliance-card d-flex align-items-center justify-content-center">
                <p>
                  Meeting up to other <b>regulatory standards</b>
                </p>
              </div>
            </Col>
          </Row>
        </div>

        <p className="page-subtitle">
          <br></br>
          We continuously strive to meet and exceed customers' expectations and
          protect the integrity of the financial system. In this regard, we have
          made significant enhancements to our control framework and practices
          which is contained in our Compliance & AML Statement covering further
          details on the following:
        </p>

        <div className="spacer"></div>

        <div className="link-button-row">
          <LinkButton
            text={
              "alrajhi bank Malaysia Wolfsberg Due Diligence Questionnaire 2024"
            }
            onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/Wolfsberg.pdf`)}
          />
          <LinkButton
            text={"Compliance & AML Statement"}
            onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/Compliance.pdf`)}
          />

          <LinkButton
            text={
              "Certification Regarding Correspondent Accounts for Foreign (of USA Patriot Act 2001)"
            }
            onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/CorrespondentAccount.pdf`)}
          />
          <LinkButton
            text={"Personal Data Protection Notice ENG"}
            onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/PDPA_EN.pdf`)}
          />
          <LinkButton
            text={
              "Certificate of Status of Beneficial Owner for United States Tax Withholding and Reporting Entities "
            }
            onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/BeneficialOwner.pdf`)}
          />
          <LinkButton
            text={"Personal Data Protection Notice BM"}
            onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/PDPA_BM.pdf`)}
          />
          <LinkButton
            text="Anti-Bribery and Corruption Statement"
            onClick={() => handleOpenPdf('https://www.alrajhibank.com.my/assets/pdf/corporate-governance/Anti-Bribery and Corruption Statement.pdf')}
          />
        </div>
      </div>
    </>
  );
}

export default Compliance;
